// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__358ZG","footer":"ReportModalFilter_footer__pdLBe"};